import { createFileRoute } from '@tanstack/react-router';
import { CreditNoteDetail } from '../../../../features/sales-invoicing/CreditNoteDetail';

/** Owned by G23. Credit note detail — approve, void guard, download PDF. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/credit-notes/$creditNoteId')({
  component: CreditNoteDetailPage,
});

function CreditNoteDetailPage() {
  const { creditNoteId } = Route.useParams();
  return <CreditNoteDetail creditNoteId={creditNoteId} />;
}
